import type {
    EventCallback,
    OrderPilotEventName,
    WidgetApi,
    WidgetUiState,
} from '../types';

export function createWidgetApi(
    ui: WidgetUiState,
): [WidgetApi, (event: OrderPilotEventName) => void] {
    const listeners = new Map<OrderPilotEventName, Set<EventCallback>>();

    function emit(event: OrderPilotEventName): void {
        for (const callback of listeners.get(event) ?? []) {
            try {
                callback();
            } catch {
                // Host callbacks must not break the widget loop.
            }
        }
    }

    const api: WidgetApi = {
        show: () => ui.setPanelOpen(true),
        hide: () => ui.setPanelOpen(false),
        toggle: () => ui.setPanelOpen(!ui.isOpen()),
        on: (event, callback) => {
            const set = listeners.get(event) ?? new Set();
            set.add(callback);
            listeners.set(event, set);
        },
    };

    return [api, emit];
}
